import { isUndefined } from "lodash";

export const stringToNumberTuple2 = (a: string, b: string): [number, number] | null =>
  !isUndefined(a) && !isUndefined(b) ? [Number(a), Number(b)] : null;
